import create from 'zustand';
import {persist} from 'zustand/middleware';

const authStore = (set) => ({
  token: null,
  user: null,
  isLogin: false,
  updateAuthDetails: ({token = null, user = null, isLogin = null}) => {
    set({
      token,
      user,
      isLogin,
    });
  },
});

const useAuthStore = create(persist(authStore, {name: 'auth'}));

export default useAuthStore;
